import Typography from '@mui/material/Typography';
import { useParams } from "infrastructure/router";
import type { PlatformSetupRouteParams } from "../../types";

const DownloadPluginContent = () => {
    const { platform } = useParams<PlatformSetupRouteParams>();

    return (
        <Typography>
            Go to <strong>Plugins</strong> in your <strong>{platform} Admin</strong> page and search for <strong>“Macropay Payments”</strong>.
        </Typography>
    );
};

export default DownloadPluginContent;
